/**
 * Turn Switch Action Types
 *
 * For the coal machine puzzle - turn switch to convert coal to diamond.
 */

export const TURN_SWITCH_ACTION_ID = 'dungeo.action.turn_switch';

export const TurnSwitchMessages = {
  NO_SWITCH: 'dungeo.turn_switch.no_switch',
  NO_COAL: 'dungeo.turn_switch.no_coal',
  ALREADY_USED: 'dungeo.turn_switch.already_used',
  SUCCESS: 'dungeo.turn_switch.success',
  DIAMOND_CREATED: 'dungeo.turn_switch.diamond_created'
};
